import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { siteInfo } from '../data/mock';
import SocialIcons from './SocialIcons';

const Footer = () => {
  const handleScroll = (sectionId) => {
    if (sectionId === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="border-t-4 border-orange-500"></div>
      
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div>
              <img 
                src="/images/logo.png" 
                alt="Changuna Aangan Logo" 
                className="h-14 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm">
              Your dream home at Diva Junction
            </p>
            {/* Social Icons */}
            <SocialIcons className="pt-2" iconSize="w-5 h-5" />
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => handleScroll('top')}
                  className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleScroll('floor-plans')}
                  className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
                >
                  Floor Plans
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleScroll('amenities')}
                  className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
                >
                  Amenities
                </button>
              </li>
              <li>
                <Link
                  to="/construction-updates"
                  className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
                >
                  Construction Updates
                </Link>
              </li>
              <li>
                <button
                  onClick={() => handleScroll('contact')}
                  className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/disclaimer"
                  className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
                >
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-4 h-4 text-orange-400 mt-1 flex-shrink-0" />
                <div className="text-sm">
                  <a href={`tel:${siteInfo.phone[0]}`} className="text-gray-400 hover:text-orange-400 transition-colors block">
                    {siteInfo.phone[0]}
                  </a>
                  <a href={`tel:${siteInfo.phone[1]}`} className="text-gray-400 hover:text-orange-400 transition-colors block">
                    {siteInfo.phone[1]}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-4 h-4 text-orange-400 mt-1 flex-shrink-0" />
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="text-gray-400 hover:text-orange-400 transition-colors text-sm"
                >
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 text-orange-400 mt-1 flex-shrink-0" />
                <p className="text-gray-400 text-sm leading-relaxed">
                  {siteInfo.address}
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400 text-center md:text-left">
              <p>© 2025 {siteInfo.projectName}. All rights reserved.</p>
              <p className="mt-1 text-xs">RERA: {siteInfo.reraNumber} | RERA Approved</p>
            </div>
            <div className="text-sm text-gray-400 text-center md:text-right">
              <p className="mb-1 text-xs italic">* Artistic impressions are subject to change</p>
              <p className="text-xs">Developed & Managed By <span className="text-orange-400 font-semibold">Dhanvi AITech</span>, Anup Dubey</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
